import { AlarmClock } from 'lucide-react';
import { Badge } from '../ui/badge';
import { KIND_META, STAGE_META, STATUS_META, timeLeftLabel } from './qualityConfig';

export const DueSoonBadge = () => (
    <Badge variant="outline" className="border-amber-300 bg-amber-50 font-semibold text-amber-900 dark:border-amber-800/60 dark:bg-amber-950/60 dark:text-amber-300">
        <AlarmClock className="mr-1 h-3 w-3 animate-pulse" /> Due soon
    </Badge>
);

export const StatusBadge = ({ status, dueSoon, testId }) => (
    <span className="inline-flex flex-wrap items-center gap-1.5">
        <Badge variant="outline" className={STATUS_META[status].className} data-testid={testId}>{STATUS_META[status].label}</Badge>
        {dueSoon && <DueSoonBadge />}
    </span>
);

export const StageBadge = ({ stage, dueSoon, testId }) => {
    const meta = STAGE_META[stage];
    const Icon = meta.icon;
    return (
        <span className="inline-flex flex-wrap items-center gap-1.5">
            <Badge variant="outline" className={`whitespace-nowrap ${meta.className}`} data-testid={testId}><Icon className="mr-1 h-3 w-3" />{meta.label}</Badge>
            {dueSoon && <DueSoonBadge />}
        </span>
    );
};

export const KindIcon = ({ kind, size = 'h-9 w-9' }) => {
    const meta = KIND_META[kind];
    const Icon = meta.icon;
    return (
        <span className={`grid shrink-0 place-items-center rounded-lg ${size} ${meta.tone}`}>
            <Icon className="h-4 w-4" />
        </span>
    );
};

export const DeadlineText = ({ task, testId }) => {
    const urgent = task.due_soon;
    const tone = task.status === 'missed' ? 'text-rose-600 dark:text-rose-400' : urgent ? 'font-semibold text-amber-600 dark:text-amber-400' : 'text-muted-foreground';
    return (
        <span className={`font-mono text-xs ${tone}`} data-testid={testId}>
            {task.status === 'completed' ? 'Done' : timeLeftLabel(task.hours_left)}
        </span>
    );
};
